import type { LinkHref } from "@octopusdeploy/portal-routes";
import { resolvePathWithSpaceId } from "@octopusdeploy/portal-routes";
import type { Location, NavigateFunction } from "react-router-dom";
import { isUrl } from "../InternalLink/isUrl";
import type { UrlResolver } from "../useUrlResolver";

export class SpaceAwareNavigation {
    constructor(
        private readonly routerNavigate: NavigateFunction,
        private readonly spaceId: string | undefined,
        private readonly urlResolver: UrlResolver
    ) {
        this.routerNavigate = routerNavigate;
        this.spaceId = spaceId;
        this.urlResolver = urlResolver;
    }

    navigate = (path: LinkHref | Location) => {
        this.routerNavigate(this.resolve(path));
    };
    redirect = (path: LinkHref | Location) => {
        this.routerNavigate(this.resolve(path), { replace: true });
    };
    open = (path: LinkHref | Location) => {
        window.open(`#${this.resolve(path)}`);
    };

    private resolve = (path: LinkHref | Location) => {
        return isUrl(path) ? this.urlResolver.resolve(path) : resolvePathWithSpaceId(path, this.spaceId);
    };
}
